module.exports = __webpack_public_path__ + "static/favicon-bb8ad32ef5f482d50d889f0de1def3d2.png";